import { Shield, Lock, Eye, FileText } from 'lucide-react';

export default function Privacy() {
  const sections = [
    {
      title: 'Our Commitment',
      icon: Shield,
      color: 'green',
      content: `DIYElectronicMech and the DIY-Mech platform family prioritize your data privacy and circuit data security. We aren't here to sell your habits; we're here to help you fix things and build circuits. This privacy policy explains how we handle your information.`
    },
    {
      title: 'Data Collection & Use',
      icon: Eye,
      color: 'cyan',
      content: `When you use ElectrAI for diagnostics, we collect your descriptions, photos, and component technical inputs to improve the AI's diagnostic accuracy. 

Personal account information is only used for authentication (via Google or Email) and for providing access to Pro features. We do not sell your personal information or shared projects to third parties.`
    },
    {
      title: 'Security Measures',
      icon: Lock,
      color: 'purple',
      content: `All diagnostic data sent through our 'Reasoning Tunnel' is encrypted both in transit and at rest. We leverage industrial-grade cloud infrastructure (Fly.io, Cloudflare) and secure databases to protect your sensitive technical data and account information.`
    },
    {
      title: 'Third Party Services',
      icon: FileText,
      color: 'amber',
      content: `We use Stripe for secure payment processing. We do not store your credit card details on our servers. We also use analytics providers (Google Analytics) to understand how you use the platform so we can improve it. We also use search and data providers (SearXNG, component APIs) to provide real-time component information and datasheets based on your queries.`
    }
  ];

  return (
    <div style={{ minHeight: 'calc(100vh - 64px)', padding: '0 1.5rem 3rem' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        
        {/* Header */}
        <div style={{ padding: '2.5rem 0 2rem', borderBottom: '1px solid var(--border-color)', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '2.2rem', fontWeight: 800, marginBottom: '0.4rem' }}>
            Privacy <span style={{ color: 'var(--color-primary)' }}>Policy</span>
          </h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>

        {/* Introduction */}
        <p style={{ color: 'var(--text-secondary)', fontSize: '1rem', lineHeight: 1.8, marginBottom: '2rem' }}>
          This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from <span style={{ color: 'var(--color-primary)', fontWeight: 600 }}>diyelectronicmech.com</span>. We understand the importance of your technical data and personal privacy in the maker and repair community.
        </p>

        {/* Sections */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {sections.map(section => {
            const colors: Record<string, string> = {
              green: 'var(--color-primary)',
              cyan: 'var(--color-secondary)',
              purple: 'var(--color-purple)',
              amber: 'var(--color-accent)'
            };
            const color = colors[section.color];

            return (
              <div key={section.title} style={{ paddingLeft: '1rem', borderLeft: `2px solid ${color}33` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.75rem' }}>
                  <div style={{ width: '32px', height: '32px', background: `${color}15`, border: `1px solid ${color}33`, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <section.icon size={16} color={color} />
                  </div>
                  <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>{section.title}</h2>
                </div>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.92rem', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                  {section.content}
                </p>
              </div>
            );
          })}
        </div>

        {/* Contact info */}
        <div style={{ marginTop: '3rem', padding: '2rem', border: '1px solid var(--border-color)', borderRadius: '16px', background: 'var(--bg-surface)' }}>
          <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.5rem' }}>Questions or concerns?</h3>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
            For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e‑mail at <span style={{ color: 'var(--color-primary)' }}>privacy@diy-mech.com</span> or by mail using the details provided in our terms.
          </p>
        </div>

      </div>
    </div>
  );
}
